module.exports = __webpack_public_path__ + "static/img/title1.e44d30a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/title1.png
// module id = qoZc
// module chunks = 1